'use strict';

require('./CallTimerFilter');
var log = require('../../log/Log').channel('SideBarController');
var defaults = require('../../defaults/Defaults');
var moment = require('moment');
var sutl = require('../../sutl/Sutl');

angular
    .module('inara')
    .directive('aveoSideBar', function () {
        // Directive that matches up the side bar template.
        return {
            restrict: 'E',
            templateUrl: 'sideBar.html',
        };
    })

    .controller('SideBarController', SideBarController);

SideBarController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    'ionicMaterialInk',
    'RoomService',
    'KayleeService',
    'gettextCatalog',
    '$ionicScrollDelegate',
    '$timeout',
];

function SideBarController(
    $rootScope,
    $scope,
    $state,
    ionicMaterialInk,
    RoomService,
    KayleeService,
    gettextCatalog,
    $ionicScrollDelegate,
    $timeout
) {
    var vm = this;
    var room = null;
    var company = null;
    var calendar = null;
    var dateFormat = 'LL';
    var urlCalendarEventId = null;
    var previousCalendarEvent = null;
    var sideBarMinimized = true;

    vm.calendarEvent = null;
    vm.calendarEventVisible = calendarEventVisible;
    /// Calendar event duration label for all day meeting
    vm.getAllDayLabel = function () {
        return gettextCatalog.getString('All day');
    };
    vm.getDate = getDate;
    vm.getTime = getTime;
    vm.isSideBarMinimized = function () {
        return sideBarMinimized;
    };
    vm.setSideBarMinimized = function (minimized, isUserAction) {
        var prev = sideBarMinimized;
        sideBarMinimized = minimized;
        if (minimized) {
            $timeout(function () {
                if ($state.current.name.startsWith('control.')) {
                    $ionicScrollDelegate.$getByHandle('side-bar-scroll').scrollTop(false);
                }
            }, 200);
        }
        if (prev !== sideBarMinimized) $rootScope.$broadcast('SideBarMinimized', sideBarMinimized);
    };

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    RoomService.onOnlineChanged(onRoomOnlineChanged);

    $scope.$on('$stateChangeSuccess', onStateChange);
    $scope.$on('RequestSideBarMinimize', onRequestSideBarMinimize);
    $scope.$on('IdleTimeout', onIdleTimeout);
    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomOnlineChanged);
        removeCallbacks();
    });

    function getCalendarFormat() {
        return {
            /// Calendar placeholder for today's date
            sameDay: '[' + gettextCatalog.getString('Today') + ']',
            /// Calendar placeholder for tomorrow's date
            nextDay: '[' + gettextCatalog.getString('Tomorrow') + ']',
            nextWeek: dateFormat,
            lastDay: dateFormat,
            lastWeek: dateFormat,
            sameElse: dateFormat,
        };
    }

    function removeCallbacks() {
        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
        if (company !== null) {
            company.$offChange(onCompanyChanged);
            company = null;
        }
        if (calendar !== null) {
            calendar.$offChange(onCalendarChanged);
            calendar = null;
        }
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (angular.isDefined(toParams.calendarEventId)) {
            urlCalendarEventId = toParams.calendarEventId;
        } else {
            urlCalendarEventId = null;
        }
        updateCalendarInfo();
        if (!anySideBarItemVisible()) vm.setSideBarMinimized(true);
    }

    function onIdleTimeout() {
        if ($state.current.name.startsWith('control.')) {
            $ionicScrollDelegate.$getByHandle('side-bar-scroll').scrollTop(true);
        }
    }

    function onRequestSideBarMinimize(event, minimize) {
        if (minimize === 'toggle') minimize = !sideBarMinimized;
        if (!minimize && !anySideBarItemVisible()) {
            log.debug('Ignoring sidebar maximize because there are no items visible');
        }
        vm.setSideBarMinimized(minimize, true);
    }

    function onRoomOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
            company = KayleeService.getCompany(room.companyId);
            company.$onChange(onCompanyChanged);
            calendar = room.$getCalendar();
            calendar.$onChange(onCalendarChanged);
        } else {
            removeCallbacks();
        }
        updateCalendarInfo();
    }

    function updateCalendarInfo() {
        var calendarConfigured =
            RoomService.online() &&
            room !== null &&
            calendar !== null &&
            sutl.getNode(room, 'caps.hasCalendar', false);

        if (
            !calendarConfigured ||
            urlCalendarEventId === null ||
            calendar === null ||
            !calendar.events.hasOwnProperty(urlCalendarEventId)
        ) {
            vm.calendarEvent = null;
            previousCalendarEvent = null;
            if (angular.isDefined($state.params.calendarEventId)) {
                $state.go($state.current.name, { calendarEventId: undefined });
            }
            return;
        }

        if (calendar.events.hasOwnProperty(urlCalendarEventId)) {
            var calendarEvent = calendar.events[urlCalendarEventId];
            if (previousCalendarEvent === null || !sutl.objEquals(previousCalendarEvent, calendarEvent)) {
                // if the calendar events have changed, we want to keep a
                // copy of the last meeting we received via the urlCalendarEventId parameter
                previousCalendarEvent = sutl.deepCopy(calendarEvent);
                vm.calendarEvent = previousCalendarEvent;
            }
        }
    }

    function onCalendarChanged() {
        updateCalendarInfo();
    }

    function onCompanyChanged() {
        updateCalendarInfo();
    }

    function onRoomChanged() {
        updateCalendarInfo();
    }

    function anySideBarItemVisible() {
        return calendarEventVisible();
    }

    function getDate(dateTime) {
        if (!RoomService.online() || room === null || dateTime === null) return '';

        var site = KayleeService.getSite(room.siteId);
        if (!site.$isLoaded()) return '';

        var timeZone = site.settings.timeZone;
        return moment(dateTime).tz(timeZone).calendar(null, getCalendarFormat());
    }

    function getTime(dateTime) {
        if (
            !RoomService.online() ||
            room === null ||
            typeof dateTime === 'undefined' ||
            dateTime === null
        ) {
            return '';
        }

        var site = KayleeService.getSite(room.siteId);
        if (!site.$isLoaded()) return '';

        var timeZone = site.settings.timeZone;
        var timeFormat = site.settings.timeFormat;
        return moment(dateTime).tz(timeZone).format(timeFormat);
    }

    function calendarEventVisible() {
        return urlCalendarEventId !== null && $state.current.name !== 'control.calendar';
    }
}

module.exports = SideBarController;
